import { styled as r, Typography as s } from "@mui/material";
import { useTranslation as i, Trans as p } from "react-i18next";
import { jsx as o } from "react/jsx-runtime";
const l = r(s)`
  color: #dddddd;
  display: inline;
  font-weight: 300;
  ${(e) => e.theme.breakpoints.up("res480")} {
    font-size: 16px;
    line-height: 34px;
  }
  ${(e) => e.theme.breakpoints.down("res480")} {
    font-size: 14px;
    line-height: 28px;
  }
  strong {
    color: rgb(245, 194, 66);
    font-weight: 400;
  }
`, h = (e) => {
  const {
    t
  } = i(), {
    subject: n
  } = e;
  return /* @__PURE__ */ o(l, {
    children: /* @__PURE__ */ o(p, {
      children: `${n}
${t("common.no_close_browser")}`
    })
  });
};
export {
  h as default
};
//# sourceMappingURL=ApeironPleaseWait.js.map
